module.exports = __webpack_public_path__ + "img/marc-bijl2.d572480e.jpg";